<template>
  <BaseCustomizeMetal componentCode="AA" useNotReverse />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAA",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 117px;
    left: 111px;
    @include betweenTableTablePro {
      top: 79px;
      left: 61px;
    }
    @include table {
      top: 60px;
      left: 36px;
    }
    @include phone {
      top: 49px;
      left: 21px;
    }
  }
  .templeName {
    height: 33px;
    width: 235px;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 279px;
    height: 58px;
    .textContainer {
      width: 279px;
    }
  }
  .gift {
    width: 171px;
    height: 33px;
    .textContainer {
      width: 171px;
    }
  }
  .respect {
    margin-left: auto;
    margin-right: 50px;
  }
}
</style>
